module.exports = __webpack_public_path__ + "5d7fd9bca5b1e6dda032084277a156f3.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-footer/sp-footer.html
// module id = 1046
// module chunks = 0